<template>
  <el-collapse v-model="extensionRequest.filtersOpen">
    <el-collapse-item
      :title="$t('common.search')"
      name="search-extensions-section"
      id="search-extensions-section">
      <el-form
        :model="searchForm"
        ref="searchForm"
        id="search-extension-request"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$t('extensionRequest.receivingDate')"
              prop="shipDate"
              class="el_label receivingDate">
              <el-date-picker
                ref="filter-datepicker"
                @change="handleChangeDate"
                v-model="searchForm.shipDate"
                format="MM/dd/yyyy"
                clearable
                :picker-options="extensionRequest.shipDatePickerOptions"
                class="el-dropdown-new drop-sp date-dob"
                type="date"
                id="searchForm-ship-date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('extensionRequest.extensionStatus')"
              prop="status"
              class="title-input">
              <el-select
                v-model="searchForm.status"
                id="searchForm-status"
                ref="filter-status"
                @change="handleSearch">
                <el-option
                  v-for="item in extensionsStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('extensionRequest.extensionHash')"
              prop="extensionNumber"
              class="el-input--mini-new-status ordernumber">
              <el-input
                v-model="searchForm.extensionNumber"
                ref="filter-order-number"
                v-alphanumeric-validation
                maxlength="25"
                clearable
                v-on:keyup.enter.native="handleSearch"
                @clear="handleSearch"
                class="inline-input"
                id="searchForm-order-number">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="w-100">
          <el-col :span="8">
            <el-form-item
              :label="$t('extensionRequest.shipper')"
              prop="shipperAccountId"
              class="shipper-filter shipper-wrp">
              <autocomplete
                :model.sync="searchForm.shipper"
                :strict="false"
                :url="urlShipper"
                labelField="name"
                labelFieldLastWithDash="number"
                :selectAction="handleSearch"
                :enterKeyAction="handleSearch"
                :clearAction="handleSearch"
                :classCss="null"
                valueField="id"
                id="searchForm-shipper"
                ref="search-shipper-list"/>
            </el-form-item>
          </el-col>
          <el-col :span="16" class="text-align-end">
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('common.search')"
                placement="top-start">
                <el-button
                  id="form-search-button"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                  class="button-action-default">
                </el-button>
              </el-tooltip>
            </span>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'SearchFilters',
  components: { Autocomplete },
  computed: {
    ...mapGetters([
      'extensionRequest'
    ])
  },
  data() {
    return {
      searchForm: {
        shipper: '',
        shipperAccountId: '',
        aelTerminal: '',
        shipDate: new Date(),
        status: constants.EXTENSION_REQUEST.EXTENSIONS_STATUS[0].value,
        extensionNumber: null
      },
      activeCollapsibleName: ['search-extensions-section'],
      extensionsStatusOptions: constants.EXTENSION_REQUEST.EXTENSIONS_STATUS,
      urlShipper: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS
    };
  },
  methods: {
    handleSearch() {
      this.searchForm.shipper = this.$refs['search-shipper-list'].getLocalModel();
      this.$store.dispatch('extensionRequest/search', this.searchForm);
    },
    /* The datepicker has an issue when change manually, the focus lost. */
    handleChangeDate() {
      this.handleSearch();
      this.$refs['filter-status'].focus();
    }
  }
};
</script>
